// @ts-nocheck

import { useState } from 'react';
import { toast } from 'sonner';
import { AlertTriangle, Loader2 } from 'lucide-react';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { deleteApiCall } from '@/service/httpCall';
import {
  API_MEDIA_STORAGE_DELETE_RECORDING,
  API_MEDIA_STORAGE_DELETE_VOICEMAIL,
} from '@/service/url';
import { friendlyApiError } from '@/utilities/apiErrorMessage';

const URL_FOR = {
  recordings: API_MEDIA_STORAGE_DELETE_RECORDING,
  voicemails: API_MEDIA_STORAGE_DELETE_VOICEMAIL,
};

const LABEL = { recordings: 'recording', voicemails: 'voicemail' };

export default function DeleteMediaDialog({ open, onOpenChange, type, row, onDeleted }) {
  const [deleting, setDeleting] = useState(false);

  const label = LABEL[type] || 'file';

  const confirm = async () => {
    if (!row?.id || deleting) return;

    setDeleting(true);
    try {
      const resp = await deleteApiCall(URL_FOR[type].replace(':id', String(row.id)));

      toast.success(
        resp?.file_reason ||
          `The ${label} was removed from the list. Its file is kept in storage.`,
      );

      onOpenChange(false);
      onDeleted?.(row.id);
    } catch (err) {
      toast.error(friendlyApiError(err) || `Could not delete this ${label}`);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(next) => (deleting ? null : onOpenChange(next))}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            Delete this {label}?
          </DialogTitle>
          <DialogDescription>This cannot be undone.</DialogDescription>
        </DialogHeader>

        <div className="rounded-md border bg-card p-3 text-sm">
          <p>
            The audio file will be <strong>permanently removed</strong>.
          </p>
          {row?.created_at && (
            <p className="mt-2 text-xs text-muted-foreground">
              Recorded {new Date(row.created_at).toLocaleString('en-IN')}
              {row.agent_name ? ` · ${row.agent_name}` : ''}
              {row.did_number || row.did ? ` · ${row.did_number || row.did}` : ''}
            </p>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={deleting}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={confirm} disabled={deleting}>
            {deleting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Remove from list
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
